import { createContext } from 'react';

export const initialState = {
  expandedColumnsIds: [],
};
const ProductContext = createContext(initialState);

export const { Provider } = ProductContext;
export default ProductContext;
